import * as Sentry from '@sentry/react';

import { config } from '../../config';

if (import.meta.env.PROD) {
    const release = config.serviceVersion;
    const environment = 'production';

    // should have been called before using it here
    // ideally before even rendering your react app
    Sentry.init({
        dsn: config.sentryToken,
        ignoreErrors: [
            'Network Error',
            'Blocked a frame with origin "https://upselling.marketplace.rio.cloud" from accessing a cross-origin frame',
            'Need to sign in',
            /Loading chunk \w+ failed/,
        ],
        environment,
        release,
    });
}

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const reportErrorToSentry = (...args: [any, any?]) => {
    Sentry.captureException(...args);
};
